import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  onClickScroll?: () => void;
}

export default function ArticleCard({ article, onClickScroll }: ArticleCardProps) {
  const categoryColors: Record<string, string> = {
    '剧情攻略': 'bg-primary-100 text-primary-700',
    '角色解析': 'bg-accent-100 text-accent-700',
    '主题评测': 'bg-secondary-100 text-secondary-700',
    '感动结局': 'bg-primary-100 text-primary-800',
    '玩家评价': 'bg-secondary-100 text-secondary-800',
  };

  const colorClass = categoryColors[article.category] || 'bg-background-200 text-foreground-700';

  return (
    <article className="bg-background-50 border border-background-200 rounded-lg overflow-hidden group hover:border-primary-300 transition-all duration-200">
      <Link
        to={`/article/${article.id}`}
        onClick={onClickScroll}
        className="block cursor-pointer"
      >
        <div className="w-full h-48 overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-2 mb-3">
          <span className={`text-xs font-medium px-2.5 py-0.5 rounded-full ${colorClass}`}>
            {article.category}
          </span>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
        </div>
        <Link
          to={`/article/${article.id}`}
          onClick={onClickScroll}
          className="cursor-pointer"
        >
          <h3 className="font-heading font-semibold text-foreground-900 text-base leading-snug mb-2 group-hover:text-primary-700 transition-colors line-clamp-2">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
            {article.excerpt}
          </p>
        </Link>
        <div className="mt-4 flex items-center justify-between">
          <div className="flex items-center gap-1.5 text-xs text-foreground-400">
            <i className="ri-calendar-line"></i>
            <span>{article.date}</span>
          </div>
          <Link
            to={`/article/${article.id}`}
            onClick={onClickScroll}
            className="text-xs text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            阅读全文
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}